// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    connectorId: z.string().min(1).max(128),
    appId: z.string().min(1).max(128),
    syncVersion: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    connectorId: z.string().min(1).max(128),
    appId: z.string().min(1).max(128),
    syncVersion: z.number(),
});
export const OrganizationDirectorySources = Object.freeze({
    table: 'organization_directory_sources',
    tableSingular: 'organization_directory_source',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        connectorId: 'connector_id',
        appId: 'app_id',
        syncVersion: 'sync_version',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'connectorId',
        'appId',
        'syncVersion',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
